import { CheckCircleIcon, ClockIcon, MapPinIcon } from "@heroicons/react/24/outline";
import React from "react";
import { EntityActivitySummary } from "./details/entity-activity-summary";
import { EntityActivityEntryProps } from "./types";

export const EntityActivityTouchpointLogged: React.FC<
    EntityActivityEntryProps
> = props => {
    const { activity } = props;
    const event = activity.activity.metadata?.events?.find(
        e => e.type === "TouchpointLogged",
    );
    const channel = event?.touchpointLogged?.channel;
    const note = event?.touchpointLogged?.note;

    return (
        <div className="relative flex items-start space-x-3">
            <div className="relative px-1">
                <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 ring-8 ring-white">
                    <CheckCircleIcon
                        className="h-5 w-5 text-gray-500"
                        aria-hidden="true"
                    />
                </div>
            </div>
            <div className="min-w-0 flex-1 group pt-1">
                <EntityActivitySummary {...props}>
                    logged a marketing touchpoint
                    {channel ? (
                        <>
                            {" "}
                            via <strong>{channel}</strong>
                        </>
                    ) : null}
                    .{note ? <div className="text-gray-500 italic">{note}</div> : null}
                </EntityActivitySummary>
            </div>
        </div>
    );
};

export const EntityActivityVisitScheduled: React.FC<EntityActivityEntryProps> = props => {
    const { activity } = props;
    const event = activity.activity.metadata?.events?.find(
        e => e.type === "VisitScheduled",
    );
    const eventDate = event?.visitScheduled?.eventDate;
    const title = event?.visitScheduled?.title;

    return (
        <div className="relative flex items-start space-x-3">
            <div className="relative px-1">
                <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 ring-8 ring-white">
                    <MapPinIcon className="h-5 w-5 text-gray-500" aria-hidden="true" />
                </div>
            </div>
            <div className="min-w-0 flex-1 group pt-1">
                <EntityActivitySummary {...props}>
                    scheduled a visit
                    {eventDate ? (
                        <>
                            {" "}
                            for{" "}
                            <strong>{new Date(eventDate).toLocaleDateString()}</strong>
                        </>
                    ) : null}
                    .{title ? <div className="text-gray-500 italic">{title}</div> : null}
                </EntityActivitySummary>
            </div>
        </div>
    );
};

export const EntityActivityTouchpointSnoozed: React.FC<
    EntityActivityEntryProps
> = props => {
    const { activity } = props;
    const event = activity.activity.metadata?.events?.find(
        e => e.type === "TouchpointSnoozed",
    );
    const scope = event?.touchpointSnoozed?.scope;
    const snoozeUntil = event?.touchpointSnoozed?.snoozeUntil;
    const reason = event?.touchpointSnoozed?.reason;
    const target = scope === "contact" ? "all outreach" : "a touchpoint";

    return (
        <div className="relative flex items-start space-x-3">
            <div className="relative px-1">
                <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 ring-8 ring-white">
                    <ClockIcon className="h-5 w-5 text-gray-500" aria-hidden="true" />
                </div>
            </div>
            <div className="min-w-0 flex-1 group pt-1">
                <EntityActivitySummary {...props}>
                    snoozed {target}
                    {snoozeUntil ? (
                        <>
                            {" "}
                            until{" "}
                            <strong>{new Date(snoozeUntil).toLocaleDateString()}</strong>
                        </>
                    ) : null}
                    .
                    {reason ? <div className="text-gray-500 italic">{reason}</div> : null}
                </EntityActivitySummary>
            </div>
        </div>
    );
};
